import { createDrawingObject, appendPoint } from "../shared";
const Brush = {
    name: "brush",
    createDraft: (startPoint) => createDrawingObject("brush", [startPoint]),
    updateDraft: (draft, nextPoint) => appendPoint(draft, nextPoint),
    render: () => undefined,
};
export default Brush;
